import { storageKey } from "../utils/configs";
import axios from "axios";
import { localRemoveItem, sessionRemoveItem } from "../utils/storage";
import { PROMOTION_BANNER_DISMISSED_KEY } from "../components/BannerWinter/BannerWinter";

const storageListener = (onLogout: () => void, e: any) => {
  if (e?.key === storageKey && e?.oldValue !== e?.newValue) {
    let token = JSON.parse(e.oldValue)?.access_token;
    axios({
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      url: `${process.env.REACT_APP_AUTH_SERVICE}/auth/revoke`,
    })
      .then(() => {})
      .catch(() => {});
    localRemoveItem();
    sessionRemoveItem();
    try {
      localStorage.removeItem(PROMOTION_BANNER_DISMISSED_KEY);
    } catch (_) {}
    onLogout();
  }
};

export default storageListener;
